import { z } from 'zod';

export const ONBOARDING_PACKET_STATUSES = [
  'pending',
  'submitted',
  'accepted',
  'not_accepted',
] as const;

export type OnboardingPacketStatus =
  (typeof ONBOARDING_PACKET_STATUSES)[number];

export const onboardingPacketsCountSchema = z.object({
  total: z.number().default(0),
  pending: z.number().default(0),
  submitted: z.number().default(0),
  accepted: z.number().default(0),
  not_accepted: z.number().default(0),
});

export type OnboardingPacketsCountDTO = z.infer<
  typeof onboardingPacketsCountSchema
>;
